import { motion, useReducedMotion } from 'framer-motion';

const ITEMS = [
  'Enrollment for 2025/2026 session is now open',
  'Secure your child\'s place today',
  'Excellence · Character · Vision',
  'Nursery · Primary · Secondary · Special Programs',
];

/** Duplicated array so the loop is seamless */
const track = [...ITEMS, ...ITEMS];

const MarqueeBanner = () => {
 const reduced=useReducedMotion();
 return (
  <div className="relative w-full bg-primary overflow-hidden py-3.5 select-none">
    {/* subtle inner shine */}
    <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" />

    {/* Marquee track — CSS animation so it runs independently of JS */}
    <ul className="sr-only">{ITEMS.map(item=><li key={item}>{item}</li>)}</ul>
    <div className={reduced ? "flex flex-wrap" : "flex whitespace-nowrap"} aria-hidden>
      <motion.div
        className={reduced ? "flex flex-wrap gap-y-2" : "flex flex-shrink-0 items-center gap-0"}
        animate={reduced ? {x:0} : { x: ['0%', '-50%'] }}
        transition={{ duration: 28, ease: 'linear', repeat: Infinity }}
      >
        {(reduced ? ITEMS : track).map((item, i) => (
          <span key={i} className="inline-flex items-center gap-6 mx-8">
            <span className="text-white font-black text-[11px] uppercase tracking-[0.28em]">
              {item}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0" />
          </span>
        ))}
      </motion.div>
    </div>
  </div>
);
};

export default MarqueeBanner;
